import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	showModal: false,
};

const studentLead = createSlice({
	name: "system",
	initialState,
	reducers: {
		toggleModelBox: state => {
			state.showModal = !state.showModal;
		},
	},
});

const { reducer, actions } = studentLead;

export const { toggleModelBox } = actions;

export default reducer;
